import React, {useEffect, useRef, useState} from "react";
import styles from "./ReferralPage.module.css";
import logo from "../../img/taxefy_logo.png";
import { isMobile } from "react-device-detect";
import { useParams } from "react-router-dom";
import * as qrcode from "qrcode";
import axios from "axios";
import environment from "../../environment";

export default function ReferralPage() {
	const { code } = useParams();
	const canvasRef = useRef(null);
	const qrCodeContainerRef = useRef(null);
	const [fallbackVisible, setFallbackVisible] = useState(false);

	function navigate(path) {
		window.location.replace(path);
	}

	const getLink = async () => {

		try {
			const response = await axios.get(`${environment.baseUrl}referral/link/${code}`);

			const url = response.data;

			if (!isMobile) {
				const canvas = canvasRef.current;

				const options = {
					width: 300,
					margin: 2,
					color: {
						dark: "#000000", // QR code color
						light: "#FFFFFF", // Background color
					},
				};

				await qrcode.toCanvas(canvas, url, options);
			} else {
				navigate(url);
			}
		} catch (e) {
			navigate("https://app.adjust.com/qdsjk20?deep_link=at.taxefy.app%3A%2F%2Fregister%3Ftaxefy_campaign%3Dtrue%26partner%3Dtaxefy&fallback=https%3A%2F%2Fapp.taxefy.at%2Fauth%2Fregister%3Ftaxefy_campaign%3Dtrue%26partner%3Dtaxefy&redirect_macos=https%3A%2F%2Fapp.taxefy.at%2Fauth%2Fregister%3Ftaxefy_campaign%3Dtrue%26partner%3Dtaxefy&label=taxefy");
		}
	};

	useEffect(() => {
		getLink();
		if (isMobile) {
			setTimeout(() => {
				setFallbackVisible(true);
			}, 1500);
		}
	}, []);

	return (
		<div className={styles["container"]}>
			<header>
				<img src={logo} alt="logo" className={styles["logo"]} />
			</header>

			<main className={styles["main"]}>
				<div>
					<h1 className={styles["title"]}>Du wurdest zu Taxefy eingeladen</h1>
					<h2 className={styles["description"]}>
						Hol deine Steuer zurück! Keine Formulare, kein Stress
					</h2>

					{isMobile && fallbackVisible && (
						<p className={styles["fallback"]}>
							Wenn die App nicht automatisch geöffnet wurde, bitte{" "}
							<a href={`${environment.baseUrl}fallback`} className={styles["link"]}>
								klicke hier
							</a>
							.
						</p>
					)}

					{/* Animated QR Code */}
					{!isMobile && (
						<div
							ref={qrCodeContainerRef}
							className={styles["qr-container"]}
						>
							<canvas ref={canvasRef} className={styles["qr-canvas"]} />
							<div className={styles["qr-overlay"]}></div>
						</div>
					)}
					<p className={styles["disclaimer"]}>
						Wir werden sehr begrenzte Informationen über die Einrichtung und Aktivität deines Kontos mit der Person teilen, die dich zu Taxefy eingeladen hat. Dies stellt sicher, dass die entsprechenden Parteien gegebenenfalls Empfehlungsprämien erhalten können.
					</p>
				</div>
			</main>

			<footer></footer>
		</div>
	);
}
